/* import __COLOCATED_TEMPLATE__ from './company-toggle.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    isOn: boolean;
    onClick: () => void;
    label: string;
    description: string;
    switchDataTest: string;
    descriptionDataTest: string;
  };
}

const CompanyToggle = templateOnlyComponent<Signature>();
export default CompanyToggle;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::CompanyToggle': typeof CompanyToggle;
    'new-settings/workspace/company-toggle': typeof CompanyToggle;
  }
}
